import { format, isValid } from "date-fns";

export function omDateFormat(inputDate) {
    if(inputDate && isValid(new Date(inputDate))) {
        return format(new Date(inputDate), 'dd.MM.yyyy')
    } else {
        return 'NA';
    } 
}